export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11174.417124c1.jpg";